var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWrapper',{attrs:{"navTitle":"Meet the team","navTitleId":"meet-team-title","routeName":"member","items":_vm.members,"backButton":{
        route: _vm.backButton.backRoute,
        label: _vm.backButton.backLabel,
    },"reverse":_vm.isIndex},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('router-view',{key:_vm.$route.path})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }